
var heightCompare = [
		'.item-1',
		'.item-2'
	];
function productColSetEqualHight(data){
	var dataLength = data.length;
	for(var i=0;i<dataLength;i++){
		var item = data[i];
		var maxH = 0;
		$(item).each(function(){
				currentHeight = $(this).outerHeight();
				if(currentHeight > maxH){
					maxH = currentHeight;
				}
			}
		);
		$(item).outerHeight(maxH);
	}
}


var itemSlick = ['.item-1', '.item-2'];
$('.slider').on('afterChange', function(event, slick, currentSlide) {
	productColSetEqualHight(itemSlick);
	$('.slick-list, .slick-track').animate({
		height : $('.slick-active').outerHeight() + 'px'
	}, 250);

})


function setEqHeightInRow(){
	$('.w-categories-2 > *:not(.related-item--cat-2)').each(function() {
		var itemEq = $(this).find('.related-item__title');
		var maxH = itemEq.eq(0).height();
		itemEq.each(function(){
			maxH = ($(this).height() > maxH) ? $(this).height() : maxH;
		});
		itemEq.height(maxH);
	});
	$('.related-item--cat-2').removeClass('equalized').unwrap();
}
function wrapItems(first,last){
	var item = $('.w-categories-2 > .related-item--cat-2');
	item.find('.related-item__title').css('height','auto');
	item.each(function(){
		var itemEq = $('.w-categories-2 > .related-item--cat-2').slice(first,last);
		itemEq.addClass('equalized');
		$('.w-categories-2 > .equalized').wrapAll('<div></div>');
	});
}

// function setEqualHeightWithSearchOfStrings() {
// 	wrapItems(0,3);
// 	setEqHeightInRow();
// }

$(window).on('load', function(){
	productColSetEqualHight(heightCompare);

	// setEqualHeightWithSearchOfStrings();
	if ($('.catalog__side-nav-list').length){
		wrapItems(0,3);
	}
	else {
		wrapItems(0,4);
	}
	setEqHeightInRow();

});